<template>
    <div class="alm-items-count-wrapper">
        <span class="items-value-span"><b>{{ value }}</b> {{ params?.colDef.field === 'count' ?  localizer.Localize('LandscapeManagement_Objects_Text') :  localizer.Localize('LandscapeManagement_Tenants_Text') }}</span>
    </div>
</template>

<script lang="ts">
import {defineComponent} from 'vue';
import { Localizer } from '@/api/Localizer';

export default defineComponent({
    props: {
        params: Object
    },
    data() {
        return {
            localizer: new Localizer(this.$store)
        };
    },
    computed: {
        value() {
            return this.params?.value;
        }
    }
});
</script>

<style>
.alm-items-count-wrapper {
    height: 100%;
}

.alm-items-count-wrapper .items-value-span {
    font-size: 14px;
    height: 24px;
    line-height: 25px;
    border-right: 1px solid #E6EBF8;
    padding-right: 16px;
}

</style>
